import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { H2 } from 'UIComponents/elements/headings';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
// @ts-expect-error migrate upstream file
import { track, EVENTS } from '../../../tracking/DashboardUITracker';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddContactsModal = ({
  onCtaClick,
  onDoThisLaterClick,
  onCloseModal
}) => {
  useEffect(() => {
    track(EVENTS.onboardingInteraction, {
      action: 'viewed add contacts modal'
    });
  }, []);
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "reporting-add-contacts-modal",
    use: "conversational",
    width: 740,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.addContactsModal.header"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCloseModal
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      className: "p-bottom-9",
      children: [/*#__PURE__*/_jsx(Text, {
        paddingInline: "1000",
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.addContactsModal.body"
        })
      }), /*#__PURE__*/_jsx(UIIllustration, {
        className: "m-top-5 m-bottom-8",
        name: "contacts",
        height: "200px",
        width: "200px"
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      align: "center",
      className: "m-bottom-9",
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: onCtaClick,
        "data-test-id": "reporting-add-contacts-cta-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.addContactsModal.guidedSetupButton"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "reporting-add-contacts-do-this-later-button",
        use: "transparent",
        onClick: onDoThisLaterClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.addContactsModal.doThisLaterButton"
        })
      })]
    })]
  });
};